// Recettes page functionality
document.addEventListener('turbolinks:load', function() {
  // Initialize Bootstrap 4 tabs for recettes
  const recettesTabs = document.querySelectorAll('.custom-tab[data-toggle="tab"]');
  
  recettesTabs.forEach(tab => {
    // Handle tab switching
    tab.addEventListener('click', function (event) {
      event.preventDefault();
      
      // Remove active class from all tabs
      recettesTabs.forEach(t => t.classList.remove('active'));
      
      // Add active class to clicked tab
      event.target.classList.add('active');
      
      // Use jQuery for Bootstrap 4 tab activation
      $(event.target).tab('show');
    });
    
    // Listen for Bootstrap tab shown event to ensure visual state is correct
    $(tab).on('shown.bs.tab', function (event) {
      // Make sure only the active tab has the active class
      recettesTabs.forEach(t => t.classList.remove('active'));
      event.target.classList.add('active');
    });
  });
});